<svelte:head>

    <title>Registration - Ämtler-Bon</title>

</svelte:head>

<script>

    import Overview from "../components/overview.svelte";

</script>


<section>

    <Overview />

</section>


<style>

    section {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        height: 100vh;
        width: 100%;
    }

    /*@media (max-width: 1024px) {*/
    /*    section {*/
    /*        height: unset;*/
    /*    }*/
    /*}*/

</style>
